/**
 * Resumen de uso de un grid de talonario (presentacional).
 *
 * Replica el bloque resumen del SSR `talonario_orders` /
 * `historical_talonario_orders` (`progress/explore_talonarios_ssr.md`, §2.3/§2.6):
 * total de números, usados (órdenes), marcados manualmente, disponibles y % de
 * uso. Recibe el grid ya cargado; sin lógica de datos.
 */
import { usagePercent } from "../format";
import type { TalonarioGrid } from "../types";

/** Un dato del resumen (etiqueta + valor). */
function SummaryItem({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="rounded-md border border-slate-200 bg-white px-4 py-3">
      <dt className="text-xs uppercase tracking-wide text-slate-500">{label}</dt>
      <dd className="text-lg font-semibold text-slate-900">{value}</dd>
    </div>
  );
}

export function TalonarioGridSummary({ grid }: { grid: TalonarioGrid }) {
  return (
    <dl className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      <SummaryItem label="Total" value={grid.total_numbers} />
      <SummaryItem label="Órdenes" value={grid.used_numbers} />
      <SummaryItem label="Marcados" value={grid.marked_count} />
      <SummaryItem label="Disponibles" value={grid.available_numbers} />
      <SummaryItem
        label="Uso"
        value={`${usagePercent(grid.total_numbers - grid.available_numbers, grid.total_numbers)}%`}
      />
    </dl>
  );
}
